import { apiClient } from './api-client';

interface ProgressResponse {
  last_index?: number | string | null;
  data?: ProgressResponse | null;
}

const toProgressValue = (value: unknown): number => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

const extractLastIndex = (payload: unknown): number => {
  if (!payload || typeof payload !== 'object') {
    return 0;
  }

  const candidate = payload as ProgressResponse;

  if (candidate.last_index !== undefined && candidate.last_index !== null) {
    return toProgressValue(candidate.last_index);
  }

  if (candidate.data) {
    return extractLastIndex(candidate.data);
  }

  return 0;
};

const normalizeProgress = (payload: unknown): { last_index: number } => ({
  last_index: extractLastIndex(payload),
});

export const progressApi = {
  async getUserProgress() {
    const { data } = await apiClient.get('/progress/me');
    return normalizeProgress(data);
  },

  async getUserProgressByLang(language: string) {
    const { data } = await apiClient.get(
      `/progress/me/${encodeURIComponent(language)}`,
    );
    return normalizeProgress(data);
  },

  async updateUserProgress(
    language: string,
    lastIndex: number,
    type: number,
  ) {
    const { data } = await apiClient.post('/progress/update', {
      language,
      last_index: lastIndex,
      type,
    });
    return normalizeProgress(data);
  },
};
